function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "carousel-arrow-right-active");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "carousel-arrow-right-active",
  transform: "translate(1.000000, 1.000000)",
  stroke: "#3f3f3d"
}, React.createElement("path", {
  d: "M0.43,64.35 L32.2,32.58 C32.3194671,32.4499369 32.3194671,32.2500631 32.2,32.12 L0.43,0.35",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "34px",
    height: "66px",
    viewBox: "0 0 34 66",
    version: 1.1
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/carousel-arrow-right-active.a291a940.svg";
export { SvgComponent as ReactComponent };